import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { View as Divider } from 'foundations-components/components/View';
import I18n from 'I18n';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { useHasCompanyPermissions } from '../hooks/useHasCompanyPermissions';
import { useIsMobile } from '../hooks/useBreakpoint';
import { UserTicketViewOption } from '../data/types';
import { usageTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TicketViewTabs = () => {
  const {
    ticketView,
    setTicketView
  } = useTicketListingsSortAndFilters();
  const hasCompanyPermissions = useHasCompanyPermissions();
  const isMobile = useIsMobile();
  if (!hasCompanyPermissions) {
    if (isMobile) return null;
    return /*#__PURE__*/_jsx(Divider, {
      marginBlock: "200",
      borderBlockStartWidth: "100",
      borderBlockStartStyle: "solid",
      borderColor: "border-core-subtle"
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "ticket-view-tabs",
    children: /*#__PURE__*/_jsxs(Tabs, {
      selected: ticketView,
      onSelectedChange: e => {
        const value = e.target.value;
        usageTracker.track('Customer Portal App', 'Tickets Discovered', {
          action: 'ticket-ownership-view-toggled',
          screen: 'ticket-listings',
          view: value
        });
        setTicketView(value);
      },
      children: [/*#__PURE__*/_jsx(Tab, {
        tabId: UserTicketViewOption.PERSONAL,
        title: I18n.text('customer-portal-app.view.my')
      }), /*#__PURE__*/_jsx(Tab, {
        tabId: UserTicketViewOption.COMPANY,
        title: I18n.text('customer-portal-app.view.all')
      })]
    })
  });
};